var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7679 8.27191C16.762 7.47814 17.3592 6.27264 17.3592 4.9707C17.3592 2.6376 15.4638 0.742188 13.1307 0.742188C11.0609 0.742188 9.33983 2.23701 8.97633 4.20289C6.66548 4.33272 4.72555 5.94623 4.17659 8.1866C1.92138 7.88245 0 9.65917 0 11.855C0 13.8951 1.65802 15.5568 3.70181 15.5568H14.848C16.8881 15.5568 18.5498 13.8988 18.5498 11.855C18.5461 10.1191 17.3777 8.67993 15.7679 8.27191ZM13.1307 1.48403C15.052 1.48403 16.6173 3.04933 16.6173 4.9707C16.6173 6.26151 15.9052 7.44476 14.7627 8.04936C14.6403 8.11242 14.5661 8.23853 14.5661 8.37577V9.09165H11.6989V8.37577C11.6989 8.23853 11.6247 8.11242 11.5023 8.04936C10.3562 7.44105 9.64769 6.26151 9.64769 4.9707C9.64398 3.04933 11.2093 1.48403 13.1307 1.48403ZM14.8443 14.815H3.70181C2.06975 14.815 0.741845 13.4871 0.741845 11.855C0.741845 10.223 2.06975 8.89877 3.70181 8.89877C3.92065 8.89877 4.15062 8.92474 4.3843 8.98038C4.48445 9.00263 4.58831 8.98409 4.67362 8.92845C4.75894 8.87281 4.81828 8.78379 4.83312 8.67993C5.18179 6.63244 6.86578 5.11536 8.90585 4.94845V4.9707C8.90585 6.46181 9.68479 7.83052 10.9571 8.59462V9.46258C10.9571 9.66658 11.124 9.8335 11.328 9.8335H14.937C15.1411 9.8335 15.308 9.66658 15.308 9.46258V8.93216C16.736 9.151 17.808 10.3676 17.808 11.8513C17.8043 13.4871 16.4764 14.815 14.8443 14.815Z",
    fill: "url(#paint0_linear_2665_14320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6576 10.5625H11.5975C11.3935 10.5625 11.2266 10.7294 11.2266 10.9334C11.2266 11.1374 11.3935 11.3043 11.5975 11.3043H14.6576C14.8616 11.3043 15.0285 11.1374 15.0285 10.9334C15.0285 10.7294 14.8653 10.5625 14.6576 10.5625Z",
    fill: "url(#paint1_linear_2665_14320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 12.0469H12.2674C12.0634 12.0469 11.8965 12.2138 11.8965 12.4178C11.8965 12.6218 12.0634 12.7887 12.2674 12.7887H13.9996C14.2036 12.7887 14.3705 12.6218 14.3705 12.4178C14.3705 12.2138 14.2036 12.0469 13.9996 12.0469Z",
    fill: "url(#paint2_linear_2665_14320)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2665_14320",
    x1: 9.27492,
    y1: 0.742187,
    x2: 9.27492,
    y2: 15.5568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2665_14320",
    x1: 13.1275,
    y1: 10.5625,
    x2: 13.1275,
    y2: 11.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2665_14320",
    x1: 13.1335,
    y1: 12.0469,
    x2: 13.1335,
    y2: 12.7887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions);
export default __webpack_public_path__ + "static/media/solutions.4749d683a26b7f872617795700113750.svg";
export { ForwardRef as ReactComponent };